// AUTO-GENERATED by scripts/set-env.js — do not edit by hand.
// Values come from .env (local) or deploy env vars. Edit .env / .env.example instead.
export const environment = {
  "production": true,
  "GoogleClientID": "35900800300-a2us1mp97alcpqh41vfdr2j6b54dkumr.apps.googleusercontent.com",
  "MicrosoftClientID": "5790a438-1279-4acd-87ec-a9fd50a2a728",
  "stripeKey": "pk_live_S1XXpjXCRDkMOgM2OVsHW50z",
  "siteName": "Let's Time IT",
  "pusherKey": "ed2e53e1b5d039546a45",
  "frontendUrl": "https://panel.letstimeit.com",
  "backendUrl": "https://api.letstimeit.com"
};
